import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Marquee from "react-fast-marquee";

import {
  banner1,
  banner2,
  closedDear,
  closedKerala,
  iButton,
  LOTTERY1,
  LOTTERY2,
  resultBf,
  resultNumber,
  support
} from "../../assets/img";

import { useLocation, useNavigate } from "react-router-dom";
import ChatModal from "../../Component/ChatModal";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Countdown from "../../Component/Countdown";
import useStore from "../redux/store/useStore";
import moment from "moment";
import useStoreKv from "../../LocalStore/useStore";
import CenterCarousel from "../../Component/CenterCarousel";

const AnnouncementMarquee = React.memo(function AnnouncementMarquee({
  text,
  onClick,
}) {
  return (
    <div
      className="looptext"
      onClick={onClick}
      style={{
        background: "#ffffff",
        color: "#000000",
        padding: "6px 0",
      }}
    >
      <Marquee gradient={false} speed={50} pauseOnHover direction="left">
        <span style={{ fontSize: 15, whiteSpace: "nowrap", marginRight: 180 }}>
          {text}
          {"            "}
        </span>
      </Marquee>
    </div>
  );
});

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          const el = document.querySelector(".backimage"); // 👈 your scroll container
          if (el) {
            el.scrollTo({ top: 0, behavior: "smooth" });
          }
        }, 0);
        getList();
      }
    }
  }, [location]);

  const { kv, set } = useStoreKv();
  const LoopText = kv.looptext || "";
  const slotLocalData = Array.isArray(kv.slotlocaldata)
    ? kv.slotlocaldata
    : [];

  const [isInfo, setIsInfo] = useState(false);
  const [isAnnounce, setIsAnnounce] = useState(false);
  const [loopText, setLoopText] = useState(LoopText);
  const [holidayReason, setHolidayReason] = useState("");
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(false);
  const openAnnounce = useCallback(() => setIsAnnounce(true), []);

  const { user, slot, messages } = useStore();
  const rawCount = messages?.unread;
  const count =
    typeof rawCount === "number" || typeof rawCount === "string"
      ? rawCount
      : 0;

  /** DEFAULT 4 SLOTS ALWAYS SHOW */
  const defaultSlots = [
    { id: "1", started_at: "1 PM", game_name: "DEAR LOTTERY", status: 10 },
    { id: "2", started_at: "3 PM", game_name: "Kerala 3 PM", status: 10 },
    { id: "3", started_at: "6 PM", game_name: "DEAR LOTTERY", status: 10 },
    { id: "4", started_at: "8 PM", game_name: "DEAR LOTTERY", status: 10 },
  ];
  const slotsData =
    Array.isArray(slot) && slot.length > 0
      ? slot
      : slotLocalData.length > 0
        ? slotLocalData
        : defaultSlots;
  const resultsData = slot ?? [
    { id: "1", game_name: "DEAR 1 PM", number: "1234", holiday: "" },
    { id: "2", name: "KERALA 3 PM", number: "", holiday: "" },
    { id: "3", name: "DEAR 6 PM", number: "", holiday: "Holiday" },
    { id: "4", name: "DEAR 8 PM", number: "", holiday: "" },
  ];
  /** GET LIST */
  const getList = async () => {
    try {
      const res = await get(`${URLS.USER}&type=3`);
      if (res?.status === "success") {
        const message =
          typeof res?.data?.message === "string" ? res.data.message : "";
        setLoopText(message);
        set("looptext", message);
      }
    } catch (err) {
      // // console.log(err);
    }

    try {
      // const slotRes = await get(URLS.SLOTLIST);
      // // console.log("Slot Response:", slotRes);
      // const apiSlots = Array.isArray(slotRes?.data) ? slotRes.data : [];
      // // console.log("apiSlots", apiSlots);
      /** ALWAYS FORMAT TO 4 SLOTS */
      // const merged = defaultSlots.map((slot, index) => {
      //     const apiSlot = apiSlots[index];
      //     if (apiSlot) {
      //         return {
      //             ...slot,
      //             ...apiSlot,
      //             started_at: apiSlot.started_at ?? slot.started_at,
      //             game_name: apiSlot.game_name ?? slot.game_name,
      //             status: apiSlot.status
      //         };
      //     }
      //     return slot;
      // });
      // setSlotsData(merged);
      // set("slotlocaldata", merged);
    } catch (err) {
      // // console.log("Slot Fetch Error:", err);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleFinish = useCallback(() => {
    // // console.log("Slot closed");
  }, []);

  return (
    <>
      <div className="backimage">
        {/* Banner Slider */}
        {/* <OwlCarousel className="owl-theme" {...options}>
                    <div className="item"><img src={'https://dl2n11pngizv0.cloudfront.net/static/banner1.png'} alt="1" /></div>
                    <div className="item"><img src={'https://dl2n11pngizv0.cloudfront.net/static/banner2.png'} alt="2" /></div>
                </OwlCarousel> */}
        <CenterCarousel />

        {/* Announcement */}
        {loopText && (
          <AnnouncementMarquee text={loopText} onClick={openAnnounce} />
        )}

        {/* Slots Section */}
        <div className="slot-container">
          <h2
            style={{ color: "#8F0D3d", fontSize: 20 }}
            className="slotname f4"
          >
            3D & 4D SLOTS
          </h2>

          <div className="slot-grid">
            {slotsData.map((it) => {
              console.log(it.status)
              const noData = it.status === 10;
              const isClosed =
                it.status === 1
                  ? false  // backend says open → always open, ignore time
                  : [2, 3, 4, 5].includes(it.status) ||
                  moment().isAfter(moment(it?.lot_closed_at));
              const isHoliday = it.status === 0;
              const isKerala = it.game_name?.toLowerCase().includes("kerala");

              const bgColor =
                noData || isClosed || isHoliday
                  ? "#838383"
                  :isKerala
                    ? "#400010"
                    : "#053662";

              const bgImage =
                noData || isClosed || isHoliday
                  ? isKerala
                    ? "https://dl2n11pngizv0.cloudfront.net/kandhaags/1779598788888.png"
                    : "https://dl2n11pngizv0.cloudfront.net/kandhaags/1779598539297.png"
                  :isKerala
                    ? "https://dl2n11pngizv0.cloudfront.net/kandhaags/1779598788888.png"
                    : "https://dl2n11pngizv0.cloudfront.net/kandhaags/1779598539297.png"

              return (
                <div
                  key={it.id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="slot-time f1"
                    style={{ backgroundColor: bgColor }}
                  >
                    {it.started_at}
                  </div>

                  <div className="slot-card">
                    <div
                      className={`slotShow ${isClosed ||
                        isHoliday ||
                        noData ||
                        moment().isAfter(
                          moment(it?.lot_closed_at, "YYYY-MM-DD HH:mm:ss"),
                        )
                        ? "disabled"
                        : "clickable"
                        }`}
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        display: "flex",
                       justifyContent: "flex-end"
                      }}
                      onClick={() => {
                        if (isHoliday) {
                          setHolidayReason(it?.holiday_reason || "Holiday");
                          setIsInfo(true);
                          return;
                        }
                        if (isClosed || noData) {
                          return;
                        }
                        navigate(
                          `/lottery-game/${it.game_name === "Kerala 3 PM" ? "kerala" : "dear"}`,
                          {
                            state: {
                              time: it?.started_at,
                              slotTime: it?.lot_closed_at,
                              bookingTime: it?.booking_closed_at,
                              lotName: it?.game_name,
                              slotId: it?.id,
                            },
                          }
                        );
                      }}
                    >
                      {/* Blur overlay only for closed slot */}
                      {(isClosed || isHoliday) && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "transparent",
                            backdropFilter: "blur(5px)",
                            WebkitBackdropFilter: "blur(5px)",
                            pointerEvents: "none", // allow clicks to pass through
                          }}
                        />
                      )}

                      {/* Existing slot content */}
                      {isHoliday ? (
                        <>
                          <h2 className="holidaycross">HOLIDAY</h2>
                          <img
                            src={iButton}
                            onClick={() => {
                              setIsInfo(true);
                              setHolidayReason(it?.holiday_reason);
                            }}
                            className="ibutton"
                          />
                        </>
                      ) : isClosed ? (
                        <div className="slot-timer2" style={{marginBottom:'55px' }}>
                          <span style={{color:"#ff0000"}}>Closed</span>
                        </div>
                      ) : noData ? (
                        ""
                      ) : (
                        <>
                          {/* <label
                            style={{ color: "white" }}
                            className="slot-label f3"
                          >
                            {it.game_name === "Kerala 3 PM"
                              ? "KERALA LOTTERY"
                              : "DEAR LOTTERY"}
                          </label> */}
                          <div className="slot-timer">
                            <Countdown
                              closingTime={it.lot_closed_at}
                              onFinish={handleFinish}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Today Results */}
        <div className="slot-container-today">
          <h2
            className="slotname f4"
            style={{ color: "#8F0D3d", fontSize: 20.5 }}
          >
            TODAY RESULTS
          </h2>
        </div>

        <div className="slot-container">
          <div className="slot-grid">
            {resultsData.map((it) => (
              <div key={it.id} onClick={() => navigate("/daily-result")}>
                {it?.winning_number && it?.winning_number !== "NULL" ? (
                  <div
                    className="slot-card2"
                    style={{ paddingTop: 12, paddingBottom: 10 }}
                  >
                    <div
                      className="slotShow2"
                      style={{
                        backgroundImage: `url(${resultBf})`,
                      }}
                    >
                      <div className="slot-contain">
                        <span className="resulttxt">{it?.winning_number}</span>
                      </div>
                      <label
                        className="slot-label2"
                        style={{ position: "relative", top: -35 }}
                      >
                        {it?.game_name}
                      </label>
                    </div>
                  </div>
                ) : (
                  <div
                    className="slot-card2"
                    style={{ paddingTop: 10, paddingBottom: 3 }}
                  >
                    <div
                      className="slotShow2"
                      style={{
                        backgroundImage: `url(${resultBf})`,
                      }}
                    >
                      <span className="holidaytext">
                        {it?.is_holiday ? "Holiday" : "Coming Soon"}
                      </span>
                      <label
                        className="slot-label2"
                        style={{ position: "relative", top: -34 }}
                      >
                        {it?.game_name}
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Download App */}
        <div
          className="download-home-bar"
          onClick={() => {
            const link = document.createElement("a");
            link.href = process.env.PUBLIC_URL + "/Kandha.apk";
            link.download = "Kandha.apk";
            link.click();
          }}
        >
          <p className="f4 primary1">
            <FileDownloadOutlinedIcon style={{ marginRight: '5px' }} /> Download App Now
          </p>
        </div>

        <div style={{ height: 100, backgroundColor: "rgb(240, 237, 230)" }} />

        {/* Announcement Modal */}
        {isAnnounce && (
          <div className="modalOverlay2" onClick={() => setIsAnnounce(false)}>
            <div className="clasInfo2" onClick={(e) => e.stopPropagation()}>
              <p className="f3">{loopText}</p>
              <button className="okBtn" onClick={() => setIsAnnounce(false)}>
                Okay
              </button>
            </div>
          </div>
        )}

        {/* Holiday Info Modal */}
        {isInfo && (
          <div className="modalOverlay2" onClick={() => setIsInfo(false)}>
            <div className="clasInfo2" onClick={(e) => e.stopPropagation()}>
              <p className="f3">{holidayReason}</p>
              <button className="okBtn" onClick={() => setIsInfo(false)}>
                Okay
              </button>
            </div>
          </div>
        )}

        {/* Chat Button */}
        <div className="chatWidth">
          <img
            src={support}
            className="supportWrap"
            alt="Support"
            onClick={() => setShowChat(true)}
            style={{ cursor: "pointer" }}
          />
          {count !== null && count !== 0 && (
            <p className="f2 noti-text2">{count}</p>
          )}
        </div>
        {/* Chat Modal */}
        {showChat && (
          <ChatModal
            visible={showChat}
            chatId={user?.id}
            onClose={() => setShowChat(false)}
          />
        )}
      </div>
    </>
  );
};

export default Home;
